/* eslint react/no-danger: "off" */

import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { MetricsElement } from 'react-metrics';
import { Link } from 'react-router';
import _ from 'lodash';

import { filterRidesByStatus, sortByClothNo } from 'modules/HorseRacing/utils/rideFilter'; // super safe cloth number sort

import OutLink from 'modules/Common/components/OutLink';
import PromoIcon from 'modules/Common/components/svg/PromoIcon';
import CaretIcon from 'modules/Common/components/svg/CaretIcon';

import HorseRacingRacecardPreRaceNotification from "./HorseRacingRacecardPreRaceNotification";
import HorseRacingRacecardRunner from './HorseRacingRacecardRunner';
import HorseRacingRacecardNonRunner from './HorseRacingRacecardNonRunner';
import HorseRacingRacecardLastYearsWinners from './HorseRacingRacecardLastYearsWinners';
import RaceVideoPlayer from 'modules/HorseRacing/components/RaceVideoPlayer';

import {buildRuleFourString, isBeforeOffStatus} from 'modules/HorseRacing/utils';
import { sortByHorseName, sortByOdds } from 'utils/compare';
import { trackClick } from 'utils/AnalyticsUtils';

export default class HorseRacingRacecardPreRace extends Component {
  static propTypes = {
    sortOrder: PropTypes.string,
    isComplete: PropTypes.bool,
    params: PropTypes.object,
    race : PropTypes.object.isRequired,
    meeting: PropTypes.object,
    meetings: PropTypes.object,
    tipsArticle: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {
      showFormExpanded: false
    };
  }

  transformData = (runners) => {
    const hn = hideNull;

    return runners.map(runner => {
      const {
        market_reference: {
          external_reference: [
            {
              value: marketId
            } = {}
          ] = []
        } = {}
      } = runner.betting;

      const medication = runner.medication ?
        runner.medication.reduce((meds, med) => {
          if (med.short_name) {
            return [...meds, med.short_name]
          }
          return meds
        }, []) : [];

      return {
        key : runner.ride_reference.id,
        status : hn(runner.ride_status),
        saddleClothNo: hn(runner.cloth_number),
        drawNumber: bracket(runner.draw_number),
        position : `${hn(runner.amended_position || runner.finish_position)}  ${bracket(runner.draw_number)}`,
        form : hn(runner.horse.formsummary.display_text),
        commentary: hn(runner.commentary),
        formWatch: hn(runner.formwatch),
        headgear: hn(runner.headgear),
        raceHistoryStats: runner.race_history_stats,
        weightPenalty: hn(runner.weight_penalty),
        insights: hn(runner.insights),
        horse : runner.horse,
        horseName : hn(runner.horse.name),
        horseLastRan: hn(runner.horse.last_ran_days),
        horseAge : hn(runner.horse.age),
        weight : hn(runner.handicap),
        rideDesc : hn(runner.ride_description),
        rideBetlinkIds: hn(getSkyBetReferences(runner)),
        trainer : runner.trainer,
        jockey : runner.jockey,
        jockeyClaim : bracket(runner.jockey_claim),
        officialRating : hn(runner.official_rating),
        odds : hn(runner.betting.current_odds),
        marketId,
        silkFilename : hn(runner.silk_filename),
        startingPriceAvailable: runner.has_sp,
        medication
      };
    });
  }

  // show last run video for runner with Id
  toggleFormExpanded = (runnerId) => {
    // if they're equal, its a toggle request
    if(this.state.showFormExpanded === runnerId){
      this.setState({showFormExpanded: null});
    } else {
      this.setState({showFormExpanded: runnerId});
    }
  }

  render() {
    const {
      race: {
        rides : raceRunners,
        naps : raceNaps,
        race_summary : raceSummary,
        race_summary : {
          promotion: {
            image,
            title,
            subtitle,
            redirect_url,
            external_link = false
          } = {},
          race_stage
        },
        videos: raceVideos,
        betting_forecast: bettingForecast,
        each_way : eachWay,
        fixture,
        market_suspended : suspended,
        deductions,
        last_years_winners : lastYearsWinners
      } = {},
      tipsArticle : {
        widgets: articleWidgets
      } = {},
      sortOrder
    } = this.props;

    switch (sortOrder) {
      case "horse":
        raceRunners.sort(sortByHorseName);
        break;
      case "odds":
        raceRunners.sort(sortByOdds);
        break;
      case "cloth":
      default:
        raceRunners.sort(sortByClothNo);
        break;
    }

    const runners = filterRidesByStatus(raceRunners, "RUNNER");
    const nonRunners = filterRidesByStatus(raceRunners, "WITHDRAWN", "NONRUNNER", "DOUBTFUL");
    const hasSkyOdds = hasSkyBetFeedOdds(runners);

    let skybetRef = getReferences(raceSummary.race_summary_reference.external_reference);
    let eventRef = skybetRef.length > 0 ? skybetRef[0] : '';

    var articleBody;
    if (articleWidgets) {
      const widgetLen = articleWidgets.length;
      for (var i = 0; i < widgetLen; i++) {
        if (articleWidgets[i].widget_type === "TextArea") {
          // For initial release assumption is that there will only be one text/html widget
          articleBody = articleWidgets[i].keys[0].value;
          break;
        }
      }
    }

    const showPromo = !!(redirect_url && isBeforeOffStatus(race_stage))
    const insightsTrackingAttrs = trackClick("insightsLinkClick", {link: "[Insights] Racecard Notification Link"});

    return (
      <section>
        {showPromo && <OutLink className="hr-racecard-promo" to={redirect_url} isExternal={external_link}>
          <span className="hr-racecard-promo-icon"><PromoIcon type={image}/></span>
          <span className="hr-racecard-promo-text">
            <span className="hr-racecard-promo-title">{title}</span>
            <span className="hr-racecard-promo-subtitle">{subtitle}</span>
          </span>
          <span className="hr-racecard-promo-caret"><CaretIcon type="line" direction="right"/></span>
        </OutLink>}
        <HorseRacingRacecardPreRaceNotification>
          <MetricsElement>
            <span> <Link {...insightsTrackingAttrs} to="/racing/insights">Keep an eye out for ‘Insights’ against a horse for additional clues towards its chance! <span className="underline">Read more...</span></Link></span>
          </MetricsElement>
        </HorseRacingRacecardPreRaceNotification>
        {
          this.transformData(runners).map(runner => {
            return <HorseRacingRacecardRunner
              runner={runner}
              raceSummary={raceSummary}
              key={runner.key}
              eventRef={eventRef}
              videos={raceVideos}
              showExpandedForm={this.state.showFormExpanded === runner.key}
              toggleFormExpanded={this.toggleFormExpanded}
              eachWay={eachWay}
              fixture={fixture}
              suspended={suspended}
              />
          })
        }
        {
          !_.isEmpty(nonRunners) &&
            <section>
              <div className="hr-racing-racecard-section-header">
                <h4>Non-Runners</h4>
              </div>
              {
                this.transformData(nonRunners).map(nonRunner => {
                  return <HorseRacingRacecardNonRunner nonRunner={nonRunner} key={nonRunner.key}/>
                })
              }
            </section>
        }

        { <section className="hr-racing-racecard-section">
            <div className="hr-racing-racecard-section-header">
              <h4>Last Year's Winner</h4>
            </div>
            <HorseRacingRacecardLastYearsWinners lastYearsWinners={lastYearsWinners} />
          </section>
        }

        { (hasSkyOdds || bettingForecast) &&
          <section className="hr-racing-racecard-section">
            <div className="hr-racing-racecard-section-header">
              <h4>Betting</h4>
            </div>
            <div className="hr-racing-racecard-section-body">
              {!hasSkyOdds && <h4>Forecast</h4>}
              {!hasSkyOdds && <p>{bettingForecast}</p>}
              {hasSkyOdds && <p>{constructBettingForecastOdds(runners)}</p>}
            </div>
          </section>
        }

        { raceSummary.verdict &&
          <section className="hr-racing-racecard-section">
            <div className="hr-racing-racecard-section-header">
              <h4>Verdict</h4>
            </div>
            <div className="hr-racing-racecard-section-body" dangerouslySetInnerHTML={{__html: raceSummary.verdict}}></div>
          </section>
        }

        { raceNaps &&
          <section className="hr-racing-racecard-section">
            <div className="hr-racing-racecard-section-header">
              <h4>Naps</h4>
            </div>
            <div className="hr-racing-racecard-section-body">{raceNaps}</div>
          </section>
        }

        { articleBody &&
          <section className="hr-racing-racecard-section">
            <div className="hr-racing-racecard-section-header">
              <h4>Tips</h4>
            </div>
            <div className="hr-racing-racecard-section-body" dangerouslySetInnerHTML={{__html: articleBody}}/>
          </section>
        }
        { (deductions && deductions.length > 0) &&
          <section className="hr-racing-racecard-rule-four">
            <div className="hr-racing-racecard-section-header">
              <h4>Rule 4</h4>
            </div>
            <div className="hr-racing-racecard-rule-four-content">
              {deductions.map((deduction, index) => (<p key={index} >{buildRuleFourString(deduction)}</p>))}
            </div>
          </section>
        }
        {
          raceVideos &&
          raceVideos.length > 0 &&
          <div className="video-replay-wrapper">
            <h4 className="video-replay-title">Video Replay</h4>
            <RaceVideoPlayer videos={raceVideos}/>
          </div>
        }
      </section>
    );
  }
}

function constructBettingForecastOdds(runners) {
  let res = '';

  runners.sort((a, b) => {
    const oddsA = a.betting.current_odds.split('/');
    const oddsB = b.betting.current_odds.split('/');
    return oddsA[0]/oddsA[1] - oddsB[0]/oddsB[1];
  });

  runners.forEach(runner => {
    res += `${runner.horse.name} (${runner.betting.current_odds}) `;
  });
  return res.trim();
}

function hasSkyBetFeedOdds(runners) {
  runners.forEach(runner => {
    if(getSkyBetReferences(runner).length > 0) {
      return true;
    }
  });
  return false;
}

const getSkyBetReferences = runner =>
  getReferences(runner.ride_reference.external_reference);

const getReferences = extRef =>
  extRef.filter(r => r.ref === 'skybet')
    .map(r => r.value);

function hideNull(element) {
  return element ? element : '';
}

function bracket(element) {
  return element ? `(${element})` : '';
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingRacecardPreRace.js